import {
  DeleteAssignmentNoteMutationVariables,
  GetMyNotesByAssignmentIdQueryVariables,
  InsertNoteMutationVariables,
} from '@school_ify/schoolify-repository/src/shared/types';
import {
  getByMyIdAndAssignmentId,
  deleteNote,
  insert as insertNote,
} from '@school_ify/schoolify-repository/src/shared/repositories/notesRepository';

export default class NotesServices {
  async insert(variables: InsertNoteMutationVariables) {
    const insertsNote = await insertNote(variables);
    return insertsNote;
  }

  async get(param: GetMyNotesByAssignmentIdQueryVariables) {
    const myNotes = await getByMyIdAndAssignmentId(param);
    return myNotes;
  }

  async delete(variables: DeleteAssignmentNoteMutationVariables) {
    const deletedNote = await deleteNote(variables);
    return deletedNote;
  }
}
